import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetActivitySchema, GetDeflectionActivityResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetDeflectionActivityResponseDataSchema>>

type Query = z.input<typeof GetActivitySchema>

type Props = {
  enabled?: boolean
  query?: Query
}

export const deflectionActivityQuery = ({ enabled = false, query }: Props = {}) => {
  return queryOptions({
    queryKey: ["deflectionActivity", JSON.stringify(query)],
    queryFn: async () => {
      const response = await axios.get<Response>(`/insights/activity/deflection`, { params: query })
      return response.data.data
    },
    enabled,
  })
}
